import React, {useState,forwardRef,useImperativeHandle} from 'react';
import '../ficha-master.css';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import CheckboxList from '../../../../components/forms/checkbox-list.jsx';
import Api from '../../../../api/global.service.js';

const ModalFichaMasterDescargaForm = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [error, setError] = useState("");
  const [ficha, setFicha] = useState(0);
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([]);
  const [categoriasFicha, setCategoriasFicha] = useState([]);
  const [configuraciones, setConfiguraciones] = useState(0);

  const schema = yup.object().shape({
    archivo: yup.string().required()
  });


  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    clearErrors,
  } = useForm({
    resolver: async (data, context, options) => {
      return yupResolver(schema)(data, context, options);
    },
    mode: "onBlur",
    defaultValues: {
      archivo: "",
    },
  });


  //To call outside
  useImperativeHandle(ref, () => ({
    show: showHandler,
    setData: (data) => setFicha(data)
  }));

  const showHandler = () => {
    setShow(true);
  };

  const closeHandler = () => {
    setShow(false);
  };


  const onSubmit = () => {

  }




  const handleChange = (e) => {
    const { value, checked } = e.target;

    const newSelectedCategorias = toggleIds(
      categoriasSeleccionadas,
      value,
      checked
    );

    setCategoriasSeleccionadas(newSelectedCategorias);
  }

  const toggleIds = (array, id, checked) => {
    if (checked) {
      return [...array, id];
    } else {
      return array.filter((item) => item !== id);
    }
  }


    const handleDownload = (event) => {
      event.preventDefault();
      Api.download("ficha/kobo/master/descarga?id_kobo_ficha_principal=" + ficha.id_kobo_ficha_principal + "&categorias=" + categoriasSeleccionadas.join(",") + "&configuraciones=" + configuraciones)
        .then(response => {
          let fileName;
          let url;
          fileName = response.headers['content-disposition'].split('filename=')[1];
          url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          link.click();
          setTimeout(() => 
            window.URL.revokeObjectURL(url), 0);
            closeHandler();
          })
        .catch(e => {
          console.log(e);
        });
    }


    React.useEffect(() => {
      if (ficha?.categorias?.length > 0) {
        // Preselect all categories
        setCategoriasSeleccionadas(ficha.categorias.map(cat => cat.id_kobo_ficha_principal_categoria +  ''));
      }
    }, [ficha]);


  return (
    <div
      className="modal"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.2)",
      }}
    >
      <div className="modal-dialog" style={{ width: 550 }}>
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-header" style={{ flex: "inherit" }}>
            <h4 className="modal-title">{props.title}</h4>
            <button
              onClick={() => closeHandler()}
              type="button"
              className="btn"
              style={{ borderRadius: "20px 20px 20px 20px" }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="m-b-15">
              {ficha?.categorias?.map((filtro,index) => {
                return (
                  <div key={index} className="checkbox">

                    <CheckboxList
                      name="ficha"
                      value={filtro.id_kobo_ficha_principal_categoria}
                      handleCheck={handleChange}
                      checked={categoriasSeleccionadas.includes(
                        filtro.id_kobo_ficha_principal_categoria + ''
                      ) || Number(filtro.obligatorio) === 1}
                    
                      disabled={Number(filtro.obligatorio) === 1}
                    />
                    <p className="titulo-checkbox">{filtro.nombre}</p>
                    </div>
                )
              })}
              <div style={{paddingTop : 0}}>
                <hr />
              <p style={{padding : 0}}>*** Otras opciones ***</p>

              </div>
              <div className="checkbox">
                <CheckboxList
                  name="configuraciones"
                  value="1"
                  handleCheck={(e) => setConfiguraciones(e.target.checked ? 1 : 0)}
                  checked={configuraciones === 1}
                />
                <p className="titulo-checkbox">Incluir configuraciones</p>
              </div>
              </div>

              <div className="form-group m-b-15">
                <span style={{ color: "red" }}>{error}</span>
              </div>

              {!blocking && (
                <button 
                  onClick={handleDownload}
                  className="btn btn-sirio"
                  style={{ borderRadius: "20px 20px 20px 20px" }}
                >
                  <i className="fa fa-download"></i> Descargar
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalFichaMasterDescargaForm;
